<template>
    <div class="c-t-default">
        <transition name="o-transition--fade" mode="out-in">
            <div v-if="!isLoading && !error && post != null && post.acf" key="content">
                <OrganismSectionRequestPuff :iframe="true" :extId="getExternalId" :content="{ title: 'Hitta hantverkare', body: ''}"></OrganismSectionRequestPuff>
            </div>
            <div v-else-if="!isLoading && error" key="error">
                <error-state></error-state>
            </div>
            <div v-else key="loading">
                <loader class="c-m-loader--x-large"></loader>
            </div>
        </transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { FETCH_CONTENT_BY_SLUG, GET_CONTENT, IS_LOADING, GET_ERROR } from '../store/store-models/content-model';

    import Hero from './components/organisms/OrganismHeroHome.vue';
    import SectionsWrapper from './SectionsWrapper.vue';
    import Loader from './components/molecules/MoleculeLoader.vue';
    import ErrorState from './components/molecules/MoleculeErrorState.vue';
    import OrganismSectionRequestPuff from './components/organisms/page-sections/OrganismSectionRequestPuff.vue'

    export default {
        async asyncData ({ store, route }) {
            return store.dispatch(FETCH_CONTENT_BY_SLUG, 'startsida');
        },
        components: {
            OrganismSectionRequestPuff,
            Hero,
            SectionsWrapper,
            Loader,
            ErrorState,
        },
        computed: {
            ...mapGetters({
                post: GET_CONTENT,
                isLoading: IS_LOADING,
                error: GET_ERROR,
            }),
            getExternalId: function() {
                const queryParams = this.$route.query;
                let externalId;
                if (queryParams.extId) {
                    externalId = this.$route.query.extId
                } else if (queryParams.extid) {
                    externalId = this.$route.query.extid
                }

                return externalId;
            }
        },
    }

</script>
<style>
body {
    background-color: white !important;
}

#cookiescript_injected_wrapper {
    display: none !important;
}

</style>


// WEBPACK FOOTER //
// src/views/IframeContent.vue